import {
  PayReportingTableRowViewModel,
  PayReportingTableRowViewModelOld,
} from '@fora-monorepo/employer-my-pages-common/types';

import { ManualPayrollReportSummary, PayrollFormData } from '../types';

import { hasInputPayDataChangedComparedToReported } from '.';

export const calculateSummary = (
  payReportingTableData: PayReportingTableRowViewModel[] | PayReportingTableRowViewModelOld[],
  inputPayData: PayrollFormData
): ManualPayrollReportSummary => {
  let totalPayAmountInNewEntries = 0;
  let numberOfNewEntries = 0;
  let totalPayAmountInChangedEntries = 0;
  let numberOfChangedEntries = 0;

  payReportingTableData.forEach(row => {
    const payInput = inputPayData[row.policyNumber];
    if (hasInputPayDataChangedComparedToReported(payInput)) {
      if (!payInput.attributablePayReported && !payInput.payAmountReported && payInput.payAmountReported !== 0) {
        numberOfNewEntries++;
        totalPayAmountInNewEntries += inputPayData[row.policyNumber].payAmount ?? 0;
      } else {
        numberOfChangedEntries++;
        totalPayAmountInChangedEntries += inputPayData[row.policyNumber].payAmount ?? 0;
      }
    }
  });

  return { totalPayAmountInNewEntries, numberOfNewEntries, totalPayAmountInChangedEntries, numberOfChangedEntries };
};
